export const API_PATH_ApiWorkzoneItemBroadcastPost = '/services/workzones-management/item/broadcast';
